var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "div",
        {
          staticClass:
            "toast qg-unpublished-page inactive-page-version-toast hidden",
          attrs: {
            role: "alert",
            "aria-live": "assertive",
            "aria-atomic": "true",
            "data-autohide": "false",
            "data-animation": "false",
          },
        },
        [
          _c("div", { staticClass: "toast-header bg-danger text-white" }, [
            _c("strong", { staticClass: "mr-auto" }, [
              _vm._v("You are viewing an inactive page version!"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "toast-body p-10 text-left" }, [
            _c("p", [
              _vm._v(
                "This page version is only visible for content publishers."
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "toast qg-unpublished-page unpublished-page-toast hidden",
          attrs: {
            role: "alert",
            "aria-live": "assertive",
            "aria-atomic": "true",
            "data-autohide": "false",
            "data-animation": "false",
          },
        },
        [
          _c("div", { staticClass: "toast-header bg-danger text-white" }, [
            _c("strong", { staticClass: "mr-auto" }, [
              _vm._v("You are viewing an unpublished page!"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "toast-body p-10 text-left" }, [
            _c("p", [
              _vm._v("This page is only visible for content publishers."),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }